import store from '../store/index';
import axios from 'axios';

let inactivityTimer;

function resetInactivityTimer() {
  clearTimeout(inactivityTimer);
  inactivityTimer = setTimeout(() => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('user');
    localStorage.removeItem('refreshToken');
    window.location.href = '/';
  }, 600000); // 10 minutes
}

document.addEventListener('mousemove', resetInactivityTimer);
document.addEventListener('mousedown', resetInactivityTimer);
document.addEventListener('keypress', resetInactivityTimer);
document.addEventListener('touchmove', resetInactivityTimer);

resetInactivityTimer();

function createAxiosInstance(baseURL) {
  const instance = axios.create({
    baseURL,
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem('accessToken').replace(/['"]+/g, '')}`
    }
  });

  instance.interceptors.response.use(
    response => response,
    error => {
      if (error.response.status === 401) {
        // unauthorized error, log out and redirect to login
        localStorage.removeItem('accessToken');
        localStorage.removeItem('user');
        localStorage.removeItem('refreshToken');
        window.location.href = '/';
      }
      return Promise.reject(error);
    }
  );

  return instance;
}


export function login() {
    return axios.create({
      baseURL: store.state.serverPath,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }     
    })
}

export function http() {
    return createAxiosInstance(store.state.apiURL);
}

export function recovery() {
  return axios.create({
    baseURL: store.state.apiURL,
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    }     
  })
}